var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dg-knowledge-base-select" },
    [
      _c(
        "el-button",
        {
          style: _vm.formItem.btnStyle,
          attrs: {
            title: _vm.formItem.tooltip,
            type: "primary",
            icon: _vm.formItem.icon,
            size: "mini",
            plain: _vm.formItem.plain,
            round: _vm.formItem.round,
            circle: _vm.formItem.circle,
            disabled: _vm.formItem.disabled,
          },
          on: {
            click: function ($event) {
              return _vm.handleClick()
            },
          },
        },
        [
          _c("span", [
            _vm._v(_vm._s(_vm.formItem.title ? _vm.formItem.title : "选择")),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "文件选择",
            visible: _vm.dialogVisible,
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.handleClose,
          },
        },
        [
          _vm.dialogVisible
            ? _c("dg-table", {
                ref: "multipleTable",
                attrs: {
                  "row-key": "KL_ID",
                  "toolbar-items": _vm.kl_toolbarItems,
                  "table-items": _vm.kl_tableItems,
                  "api-code": "sysKnowledge",
                  "query-terms": "KL_NODE=" + _vm.rowCode,
                  height: _vm.height,
                },
                on: { selectionChange: _vm.selectionColChange },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.tableModel.tableData.length > 0
        ? [
            _c(
              "el-table",
              {
                ref: "knowledgeBaseTable",
                staticStyle: { width: "100%" },
                attrs: { data: _vm.tableModel.tableData },
              },
              [
                _vm._l(_vm.tableModel.list_tableItems, function (item) {
                  return [
                    _c("el-table-column", {
                      key: item.KL_ID,
                      attrs: {
                        label: item.title,
                        prop: item.field,
                        width: item.width,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(scope.row[item.field]) +
                                    "\n            "
                                ),
                                item.actions && item.actions.length > 0
                                  ? _c(
                                      "div",
                                      _vm._l(
                                        item.actions,
                                        function (inItem, idx) {
                                          return _c(
                                            "span",
                                            { key: idx },
                                            [
                                              _c("el-button", {
                                                style: inItem.style,
                                                attrs: {
                                                  icon: inItem.icon,
                                                  plain: inItem.plain,
                                                  type: inItem.type,
                                                  size: "small",
                                                  tooltip: item.tooltip,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.clickHandle(
                                                      item,
                                                      scope.row,
                                                      scope.$index,
                                                      $event,
                                                      inItem
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                  ]
                }),
              ],
              2
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }